import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Login from '../views/Login.vue'
import Logout from '../views/Logout.vue'
import Callback from '../views/AuthCallback.vue'
import Tokenize from '../views/AuthTokenize.vue'
import Passthrough from '../views/Passthrough.vue'
import ErrorMsg from '../views/AuthError.vue'
import EditProfile from '../views/EditProfile.vue'
import CreateReservation from '../views/CreateReservation.vue'
import ManageReservations from '../views/ManageReservations.vue'
import store from '@/store/index';

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'index',
    component: Index,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      requiresAuth: false
    },
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
    meta: {
      requiresAuth: false
    },
  },
  {
    path: '/callback',
    name: 'callback',
    component: Callback,
    meta: {
      title: 'Authenticating...',
      auth: false
    }
  },
  {
    path: '/tokenize',
    name: 'tokenize',
    component: Tokenize,
    meta: {
      title: 'Tokenizing...',
      auth: false
    }
  },
  {
    path: '/passthrough',
    name: 'passthrough',
    component: Passthrough,
    meta: {
      auth: false
    }
  },
  {
    path: '/error',
    name: 'error',
    component: ErrorMsg,
    meta: {
      auth: false
    }
  },
  {
    path: '/edit-profile',
    name: 'editProfile',
    component: EditProfile
  },
  {
    path: '/create-reservation',
    name: 'createReservation',
    component: CreateReservation
  },
  {
    path: '/manage-reservations',
    name: 'manageReservations',
    component: ManageReservations
  },
  {
    path: '/season/:season_id',
    name: 'index',
    component: Index,
    meta: {
      requiresAuth: true
    },
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.auth.isAuthenticated) {
      next({
        path: '/login',
        params: {
          nextUrl: to.fullPath
        }
      })
    } else {
      store.commit('onError', null)
      store.commit('onSuccess', null)
      next()
    }
  } else {
    next()
  }
})